export class EnvironmentService {
  static getBaseUrl(): string {
    if (window.location.port === "8080") {
      return window.location.protocol + "//" + window.location.hostname + ":9101";
    }

    return "";
  }

  static isDevelopment(): boolean {
    return !!this.getBaseUrl();
  }
}
